import { Checkbox } from '@/components/ui/checkbox'
import { cn } from '@/lib/utils'

/**
 * Figma (node 46:112):
 * Layout: flex gap-2 items-start
 * Checkbox: 16px rounded-[4px], border-input (unchecked) / bg-primary border-primary (checked)
 * Focus: shadow-[0px_0px_0px_3px_rgba(163,163,163,0.5)]
 * Disabled: checkbox opacity-50, label opacity-70
 * Invalid: border-destructive, bg-destructive (checked), label text-destructive
 * Label: text-sm font-medium leading-none
 * Description: text-sm text-muted-foreground, gap-1.5 from label
 */
export interface IntuiCheckboxProps {
  id?: string
  checked?: boolean | 'indeterminate'
  onCheckedChange?: (checked: boolean | 'indeterminate') => void
  disabled?: boolean
  /** Show invalid/error state — red border, red fill when checked, red label */
  invalid?: boolean
  label?: string
  description?: string
  className?: string
}

function IntuiCheckbox({ id, checked, onCheckedChange, disabled, invalid, label, description, className }: IntuiCheckboxProps) {
  const checkboxId = id ?? `intui-checkbox-${Math.random().toString(36).slice(2, 9)}`
  return (
    <div className={cn('flex items-start gap-2', className)}>
      <Checkbox id={checkboxId} checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} invalid={invalid} className="mt-0.5" />
      {(label || description) && (
        <div className="flex flex-col gap-1.5">
          {label && (
            <label
              htmlFor={checkboxId}
              className={cn(
                'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
                invalid && 'text-destructive'
              )}
            >
              {label}
            </label>
          )}
          {description && <p className="text-sm leading-5 text-muted-foreground">{description}</p>}
        </div>
      )}
    </div>
  )
}

export { IntuiCheckbox }
